// extracted by mini-css-extract-plugin
export default {"main":"InfoNav_main__euMoZ","container":"InfoNav_container__WQP-W","exploreButton":"InfoNav_exploreButton__zdwWt","rightSection":"InfoNav_rightSection__CHLIZ"};